import React from 'react';
import * as Styled from './ModalFooter.styles';

export const ModalFooter = ({ children }: { children?: React.ReactNode }) => {
  return <Styled.ModalFooter>{children}</Styled.ModalFooter>;
};
